import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTER_GARAGE_DETAILS, ROUTER_MY_NETWORK } from 'app/AppRouter';
import { GarageDetailsPage } from 'pages/MyNetworkPage/GarageDetails/GarageDetailsPage';
import { MyNetworkPage } from 'pages/MyNetworkPage/MyNetworkPage';

export const MyNetworkRouter = () => (
  <Switch>
    <Route path={`${ROUTER_MY_NETWORK}${ROUTER_GARAGE_DETAILS}`} component={GarageDetailsPage} />
    <Route path={'*'} component={MyNetworkPage} />
  </Switch>
);
